import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '@/app/auth.service';
import { inject } from '@angular/core';
import { of } from 'rxjs';
import { RoutingPaths } from '@/app/common/routing';

export const NotLoggedInUsersGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const activate = !authService.isLoggedIn(true) || authService.requires2FA();

  if (!activate) {
    console.log('Cannot navigate to login page, user already logged in', route, state);
    router.navigate([RoutingPaths.MainView]);
  }

  return of(activate);
};
